const namespace = 'client';
const applicationErrorType = 'ApplicationError';
const networkErrorType = 'NetworkError';

export default () => ({
  'js-exception': {
    make: meta => ({
      type: applicationErrorType,
      payload: {
        ...meta,
        errorMessage: meta?.message,
        error: meta?.error?.name,
        eventType: 'js-exception',
        namespace,
        timestamp: new Date(),
        type: applicationErrorType,
        eventId: `${namespace}:${applicationErrorType}`,
      },
    }),
  },
  'unhandled-rejection:error': {
    make: meta => ({
      type: applicationErrorType,
      payload: {
        ...meta,
        errorMessage: meta?.error?.message,
        error: meta?.error?.name,
        errorType: 'unhandled-rejection',
        namespace,
        timestamp: new Date(),
        type: applicationErrorType,
        eventId: `${namespace}:${applicationErrorType}`,
      },
    }),
  },
  'application:error': {
    make: meta => ({
      type: applicationErrorType,
      payload: {
        ...meta,
        namespace,
        timestamp: new Date(),
        type: applicationErrorType,
        eventId: `${namespace}:${applicationErrorType}`,
      },
    }),
  },
  'network:error': {
    make: meta => ({
      type: networkErrorType,
      payload: {
        ...meta,
        namespace,
        timestamp: new Date(),
        type: networkErrorType,
        eventId: `${namespace}:${networkErrorType}`,
      },
    }),
  },
});
